// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("img/heightgraph-area-chart.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("img/heightgraph-remove.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heightgraph-container {
    background-color: rgba(250, 250, 250, 0.8);
    border-radius: 10px;
    display: none;
    cursor: default;
    user-select: none;
}

.heightgraph-toggle {
    cursor: pointer;
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.4);
    border-radius: 5px;
    width: 28px;
    height: 28px;
    background: #f8f8f9;
    display: block;
}

.heightgraph-toggle-icon {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
    background-size: 14px 14px;
    width: 26px;
    height: 26px;
    position: absolute;
}

.heightgraph-close-icon {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center center;
    background-size: 14px 14px;
    width: 26px;
    height: 26px;
    position: absolute;
    right: 0;
    display: none;
    cursor: pointer;
}

.border-top {
    fill: none;
}

.legend-text {
    fill: #000;
    font-size: 10px;
    cursor: pointer;
}

.tick,
.tick text {
    fill: #000;
    pointer-events: none;
}

.axis .tick line {
    visibility: hidden;
    pointer-events: none;
}

.axis path {
    stroke: black;
    fill: none;
    stroke-width: 2px;
    shape-rendering: crispEdges;
    pointer-events: none;
}

.focusbox {
    display: none;
    font-size: 10px;
    fill: #000;
    pointer-events: none;
}

.focusbox rect {
    fill: rgba(255, 255, 255, 0.8);
    stroke-width: 1px;
    stroke: #888;
    pointer-events: none;
}

.focusbox text {
    font-size: 12px;
}

.focusLine line {
    stroke-width: 1px;
    stroke: rgb(20, 20, 20);
    display: none;
    cursor: default;
    shape-rendering: crispEdges;
}

.height-focus.label rect {
    fill: rgba(255, 255, 255, 0.5);
    stroke-width: 1px;
    stroke: #888;
    pointer-events: none;
    shape-rendering: crispEdges;
}

.height-focus.line {
    stroke: rgb(20, 20, 20);
    stroke-width: 1px;
    shape-rendering: crispEdges;
}

.height-focus.circle {
    stroke: #fff;
    stroke-width: 1px;
}

.mouse-height-box-text {
    font-size: 12px;
}

.grid .tick {
    pointer-events: none;
}

.grid .tick line {
    stroke: #eee;
    stroke-width: 1px;
    shape-rendering: crispEdges;
}

.grid path {
    stroke-width: 0;
    pointer-events: none;
}

.tspan {
    font-weight: bold;
}

.select-symbol {
    cursor: pointer;
}

.select-info {
    cursor: default;
}

.lineSelection {
    cursor: move;
}

.heightgraph-show {
    display: block !important;
}

#heightgraph-legend {
    position: absolute;

    cursor: pointer;
    right: 15px;
    bottom: 10px;
    font-size: 14px;
}

#heightgraph-legend-text {
    float: right;
}

#heightgraph-legend-icon {
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-right: 5px;
}

#heightgraph-legend ul {
    position: relative;
    right: -7px;
    min-width: 30px;
    display: none;

    margin: 0 5px 7px 5px;
    padding: 0 15px 5px 5px; /* Add padding to the right to avoid that the scrollbar hides content */
    list-style: none;
    background-color: white;
    border: 1px solid #ccc;
    border-radius: 4px;

    max-height: 120px;
    overflow-y: auto;
}

#heightgraph-selector {
    position: absolute;
    bottom: 0;
    width: 200px;
}

#arrow-icon-for-input {
    font-size: 16px;

    position: absolute;
    right: 11px;
    bottom: 9px;
    pointer-events: none; /* let clicks through to input */
}

#heightgraph-selector input {
    font-size: 14px;

    width: 180px;
    background-color: transparent;
    cursor: pointer;

    margin: 0 5px 5px 5px;
    padding: 3px 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

#heightgraph-selector ul {
    font-size: 14px;
    display: none;
    top: -100%;

    margin: 0 5px;
    padding: 0 5px;
    list-style: none;
    background-color: white;
    border: 1px solid #ccc;
    border-radius: 4px;

    max-height: 120px;
    overflow-y: auto;
}

#heightgraph-selector ul li {
    padding: 5px 0;
    cursor: pointer;
}

#heightgraph-selector ul li:hover {
    background-color: #f5f5f5;
}
`, "",{"version":3,"sources":["webpack://./src/pathDetails/HeightGraph.css"],"names":[],"mappings":"AAAA;IACI,0CAA0C;IAC1C,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,wCAAwC;IACxC,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,2EAAuE;IACvE,0BAA0B;IAC1B,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,2EAAmE;IACnE,0BAA0B;IAC1B,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,eAAe;IACf,eAAe;AACnB;;AAEA;;IAEI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,iBAAiB;IACjB,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,YAAY;IACZ,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;;IAElB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,aAAa;;IAEb,qBAAqB;IACrB,uBAAuB,EAAE,uEAAuE;IAChG,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;;IAElB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,eAAe;;IAEf,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,oBAAoB,EAAE,gCAAgC;AAC1D;;AAEA;IACI,eAAe;;IAEf,YAAY;IACZ,6BAA6B;IAC7B,eAAe;;IAEf,qBAAqB;IACrB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,UAAU;;IAEV,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;;IAElB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".heightgraph-container {\n    background-color: rgba(250, 250, 250, 0.8);\n    border-radius: 10px;\n    display: none;\n    cursor: default;\n    user-select: none;\n}\n\n.heightgraph-toggle {\n    cursor: pointer;\n    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.4);\n    border-radius: 5px;\n    width: 28px;\n    height: 28px;\n    background: #f8f8f9;\n    display: block;\n}\n\n.heightgraph-toggle-icon {\n    background: url(img/heightgraph-area-chart.svg) no-repeat center center;\n    background-size: 14px 14px;\n    width: 26px;\n    height: 26px;\n    position: absolute;\n}\n\n.heightgraph-close-icon {\n    background: url(img/heightgraph-remove.svg) no-repeat center center;\n    background-size: 14px 14px;\n    width: 26px;\n    height: 26px;\n    position: absolute;\n    right: 0;\n    display: none;\n    cursor: pointer;\n}\n\n.border-top {\n    fill: none;\n}\n\n.legend-text {\n    fill: #000;\n    font-size: 10px;\n    cursor: pointer;\n}\n\n.tick,\n.tick text {\n    fill: #000;\n    pointer-events: none;\n}\n\n.axis .tick line {\n    visibility: hidden;\n    pointer-events: none;\n}\n\n.axis path {\n    stroke: black;\n    fill: none;\n    stroke-width: 2px;\n    shape-rendering: crispEdges;\n    pointer-events: none;\n}\n\n.focusbox {\n    display: none;\n    font-size: 10px;\n    fill: #000;\n    pointer-events: none;\n}\n\n.focusbox rect {\n    fill: rgba(255, 255, 255, 0.8);\n    stroke-width: 1px;\n    stroke: #888;\n    pointer-events: none;\n}\n\n.focusbox text {\n    font-size: 12px;\n}\n\n.focusLine line {\n    stroke-width: 1px;\n    stroke: rgb(20, 20, 20);\n    display: none;\n    cursor: default;\n    shape-rendering: crispEdges;\n}\n\n.height-focus.label rect {\n    fill: rgba(255, 255, 255, 0.5);\n    stroke-width: 1px;\n    stroke: #888;\n    pointer-events: none;\n    shape-rendering: crispEdges;\n}\n\n.height-focus.line {\n    stroke: rgb(20, 20, 20);\n    stroke-width: 1px;\n    shape-rendering: crispEdges;\n}\n\n.height-focus.circle {\n    stroke: #fff;\n    stroke-width: 1px;\n}\n\n.mouse-height-box-text {\n    font-size: 12px;\n}\n\n.grid .tick {\n    pointer-events: none;\n}\n\n.grid .tick line {\n    stroke: #eee;\n    stroke-width: 1px;\n    shape-rendering: crispEdges;\n}\n\n.grid path {\n    stroke-width: 0;\n    pointer-events: none;\n}\n\n.tspan {\n    font-weight: bold;\n}\n\n.select-symbol {\n    cursor: pointer;\n}\n\n.select-info {\n    cursor: default;\n}\n\n.lineSelection {\n    cursor: move;\n}\n\n.heightgraph-show {\n    display: block !important;\n}\n\n#heightgraph-legend {\n    position: absolute;\n\n    cursor: pointer;\n    right: 15px;\n    bottom: 10px;\n    font-size: 14px;\n}\n\n#heightgraph-legend-text {\n    float: right;\n}\n\n#heightgraph-legend-icon {\n    display: inline-block;\n    width: 10px;\n    height: 10px;\n    margin-right: 5px;\n}\n\n#heightgraph-legend ul {\n    position: relative;\n    right: -7px;\n    min-width: 30px;\n    display: none;\n\n    margin: 0 5px 7px 5px;\n    padding: 0 15px 5px 5px; /* Add padding to the right to avoid that the scrollbar hides content */\n    list-style: none;\n    background-color: white;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n\n    max-height: 120px;\n    overflow-y: auto;\n}\n\n#heightgraph-selector {\n    position: absolute;\n    bottom: 0;\n    width: 200px;\n}\n\n#arrow-icon-for-input {\n    font-size: 16px;\n\n    position: absolute;\n    right: 11px;\n    bottom: 9px;\n    pointer-events: none; /* let clicks through to input */\n}\n\n#heightgraph-selector input {\n    font-size: 14px;\n\n    width: 180px;\n    background-color: transparent;\n    cursor: pointer;\n\n    margin: 0 5px 5px 5px;\n    padding: 3px 5px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n}\n\n#heightgraph-selector ul {\n    font-size: 14px;\n    display: none;\n    top: -100%;\n\n    margin: 0 5px;\n    padding: 0 5px;\n    list-style: none;\n    background-color: white;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n\n    max-height: 120px;\n    overflow-y: auto;\n}\n\n#heightgraph-selector ul li {\n    padding: 5px 0;\n    cursor: pointer;\n}\n\n#heightgraph-selector ul li:hover {\n    background-color: #f5f5f5;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
